module.exports = __webpack_public_path__ + "static/media/gymate3.48b26e53.png";